import React, { Component } from 'react';
import { db } from '../firebase/Firebase';
import ReactToPrint from "react-to-print";
import { flattenDoc, getYearStart } from '../Util';
import ColType from '../Types';
import { Collapse, notification, Button, Icon, Popconfirm, DatePicker } from 'antd';
import Empty from '../customcomponents/Empty';
import PersonAvatar from '../customcomponents/PersonAvatar';
import moment from 'moment';
import ProfessionalLearningReportForm from './ProfessionalLearningReportForm';
import ProfessionalLearningReportUpdateForm from './ProfessionalLearningReportUpdateForm';
import ConsultationReportForm from './ConsultationReportForm';
import ConsultationReportUpdateForm from './ConsultationReportUpdateForm';
const { Panel } = Collapse;
var html2pdf = null
if (typeof window !== 'undefined') {
    html2pdf = require('html2pdf.js')
}

const successMessage = (description) => {
    notification.open({
        type: 'success',
        message: description,
        placement: 'bottomRight'
    });
};

const errorMessage = (description) => {
    notification.open({
        type: 'error',
        message: description,
        placement: 'bottomRight'
    });
};

class ConsultationReport extends Component {
    state = {
        reports: [],
        reportsMounted: false,
        reportsListener: null,
        reportKeys: [
            'description',
        ],
    };

    componentDidMount() {
        let reportsListener = db.collection(ColType.consultationReport)
            .where('districtId', '==', this.props.districtId)
            .where('schoolId', '==', this.props.schoolId)
            .orderBy('timeStamp', 'desc')
            .limit(300)
            .onSnapshot((querySnapshot) => {
                let reports = [];
                querySnapshot.forEach((doc) => {
                    reports.push(flattenDoc(doc));
                });
                this.setState({
                    reports: reports,
                    reportsMounted: true
                });
            });

        this.setState({
            reportsListener: reportsListener
        });
    }

    componentWillUnmount() {
        if (this.state.reportsListener) {
            this.state.reportsListener();
        }
    }

    // Normalize whatever getYearStart() returns (moment, Date, Firestore
    // timestamp, or a number in seconds/ms) into milliseconds so it can be
    // compared against report.timeStamp.seconds * 1000.
    getYearStartMs = () => {
        let yearStart = getYearStart();
        if (yearStart === null || yearStart === undefined) {
            return null;
        }
        if (moment.isMoment(yearStart)) {
            return yearStart.valueOf();
        }
        if (yearStart instanceof Date) {
            return yearStart.getTime();
        }
        if (typeof yearStart === 'object' && yearStart.seconds !== undefined) {
            // Firestore Timestamp-like object
            return yearStart.seconds * 1000;
        }
        if (typeof yearStart === 'number') {
            // Heuristic: values below ~1e12 are almost certainly seconds
            return yearStart < 1e12 ? yearStart * 1000 : yearStart;
        }
        let parsed = moment(yearStart);
        return parsed.isValid() ? parsed.valueOf() : null;
    };

    // Extracted so the same panel markup can be reused for current-year
    // reports and previous-year reports.
    renderReportPanel = (report) => {
        let contentRefName = 'content-' + report.id;
        return (
            <Panel
                header={
                    <div className='font-20 w-100 flex flex-v-center'>
                        <div className='ellipsis' style={{ maxWidth: '400px' }}>{report.firstName + ' ' + report.lastName}</div>
                        <div className='ml-auto flex flex-v-center'>
                            <span className='font-16 pl-05'>
                                {(report.timeStamp ? moment.utc(report.timeStamp.seconds * 1000).format("MM/DD/YYYY") : '')}
                            </span>
                        </div>
                    </div>
                }
                key={report.id}
            >
                <div className='pt-2'>
                    <div className='font-20 mb-2 flex flex-v-center w-100 font-black'>
                        <div className='ml-auto flex flex-v-center'>
                            <ConsultationReportUpdateForm
                                districtId={this.props.districtId}
                                schoolId={this.props.schoolId}
                                report={report}
                            />
                            <ReactToPrint
                                trigger={() =>
                                    <Button
                                        type="default"
                                        className="lg-btn mr-1"
                                    >
                                        <Icon type="download" /> Download
                                    </Button>
                                }
                                content={() => this[contentRefName]}
                                print={async (printIframe) => {
                                    if (!html2pdf) {
                                        return new Promise((resolve, reject) => { resolve() })
                                    }
                                    const document = printIframe.contentDocument
                                    if (document) {
                                        const html = document.getElementsByTagName('html')[0]
                                        await html2pdf().from(html).set({
                                            image: { type: 'png', quality: 1.0 },
                                            html2canvas: { scale: 1.0 },
                                            margin: 12,
                                            pagebreak: { mode: ['avoid-all', 'css'], avoid: '.page-break-inside-avoid' },
                                        }).save('Dot-It-Consultation-Report.pdf')
                                    }

                                    return new Promise((resolve, reject) => { resolve() })
                                }}
                            />
                            <ReactToPrint
                                trigger={() => (
                                    <Button
                                        type="default"
                                        className="lg-btn mr-1"
                                    >
                                        <Icon type="printer" /> Print
                                    </Button>
                                )}
                                content={() => this[contentRefName]}
                            />


                            {/*this.props.personId === report.personId ?
                                <Popconfirm
                                    title="Are you sure you want to delete this report?"
                                    onConfirm={() => {
                                        db.collection(ColType.consultationReport)
                                            .doc(report.id)
                                            .delete()
                                            .then(() => {
                                                successMessage('Report deleted successfully.');
                                            })
                                            .catch((error) => {
                                                console.log(error);
                                                errorMessage('Error deleting report, please try again.');
                                            });
                                    }}
                                    okText="Yes"
                                    cancelText="No"
                                >
                                    <Button
                                        type="danger"
                                        className="br-50 flex flex-v-center flex-h-center font-20"
                                        style={{
                                            padding: '16px',
                                            width: '50px',
                                            height: '50px'
                                        }}
                                    >
                                        <Icon type="delete" />
                                    </Button>
                                </Popconfirm> : ''*/}
                        </div>
                    </div>
                    <div ref={el => (this[contentRefName] = el)}>
                        <div className='font-black'>
                            <div>
                                <img src="/logo-icon.png" alt="logo" height="120" />
                            </div>
                            <div>
                                <div className='font-24 mb-2'>Consultation Report</div>
                            </div>
                            <div>
                                <div className='font-20'>{report.firstName + ' ' + report.lastName}</div>
                            </div>
                            <div className='mb-2'>
                                <div className='font-16'>{report.timeStamp ? moment.utc(report.timeStamp.seconds * 1000).format("MM/DD/YYYY") : ''}</div>
                            </div>
                            <div className='mb-2'>
                                <div className='font-16'>
                                    {report.description.includes('\n')
                                        ? report.description.split('\n').map((line, index) => (
                                            <div key={index} className='page-break-inside-avoid' style={{ marginBottom: '20px' }}>
                                                {line}
                                            </div>
                                        ))
                                        : report.description}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Panel>
        );
    };

    render() {
        // Split reports into current year vs. previous years based on yearStart.
        let yearStartMs = this.getYearStartMs();
        let currentReports = [];
        let previousReports = [];
        this.state.reports.forEach((report) => {
            let ts = report.timeStamp ? report.timeStamp.seconds * 1000 : null;
            // Reports with no timestamp (or when we can't resolve yearStart)
            // stay visible in the current section rather than being hidden.
            if (yearStartMs === null || ts === null || ts >= yearStartMs) {
                currentReports.push(report);
            } else {
                previousReports.push(report);
            }
        });

        return (
            <div>
                <div className='w-100 flex flex-v-center mb-2'>
                    <div className='font-30 font-bold'>Consultation Reports</div>
                    <ConsultationReportForm
                        districtId={this.props.districtId}
                        schoolId={this.props.schoolId}
                        personId={this.props.personId}
                    />
                </div>

                <div>
                    {this.state.reportsMounted ?
                        this.state.reports.length === 0 ?
                            <Empty
                                containerClassName="mt-2 text-center"
                                width={55}
                                height={55}
                                image={'/empty/goals.png'}
                                description={'There are currently no consultation reports.'}
                            />
                            :
                            <div>
                                {currentReports.length === 0 ?
                                    <Empty
                                        containerClassName="mt-2 text-center"
                                        width={55}
                                        height={55}
                                        image={'/empty/goals.png'}
                                        description={'There are currently no consultation reports for this year.'}
                                    />
                                    :
                                    <Collapse bordered={true}>
                                        {currentReports.map((report) => this.renderReportPanel(report))}
                                    </Collapse>
                                }

                                {previousReports.length > 0 ?
                                    <div className='mt-3'>
                                        <Collapse bordered={true}>
                                            <Panel
                                                header={
                                                    <div className='font-20 w-100 flex flex-v-center'>
                                                        <div>Previous Years</div>
                                                        <div className='ml-auto font-16'>
                                                            {previousReports.length}
                                                            {previousReports.length === 1 ? ' report' : ' reports'}
                                                        </div>
                                                    </div>
                                                }
                                                key='previous-years'
                                            >
                                                <Collapse bordered={true}>
                                                    {previousReports.map((report) => this.renderReportPanel(report))}
                                                </Collapse>
                                            </Panel>
                                        </Collapse>
                                    </div>
                                    : ''}
                            </div>
                        : ''}
                </div>
            </div>
        );
    }
}

export default ConsultationReport;